import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { Spinner } from 'lib/ui/components'
import { useSubscriptionOrders } from 'hooks/subscriptions'
import { SubscriptionItem } from '../../../../components/SubscriptionItem'
import { Box, SubscriptionInfo } from '../Styled'

export const Subscriptions = () => {
  const { firstSubscriptionItem, loading, customerSubscriptions } = useSubscriptionOrders()

  if (loading) {
    return <Spinner />
  }

  return (
    <Box style={{ marginBottom: 10 }}>
      <FlexWrapper className='flex-box'>
        <h3>
          <FormattedMessage id='customer.account.dashboard.schedule' />
        </h3>
        {customerSubscriptions && customerSubscriptions?.length > 1 && (
          <Link to='/customer/account/subscriptions'>
            <FormattedMessage id='customer.account.dashboard.subscriptions' />
          </Link>
        )}
      </FlexWrapper>
      <Box className='border-box'>
        <SubscriptionInfo>
          {firstSubscriptionItem ? (
            <>
              <SubscriptionItem
                item={firstSubscriptionItem}
              />
            </>
          ) : (
            <h4>You don't have any subscription orders yet. Subscriptions details may take a few minutes to display in your account dashboard following signup.</h4>
          )}
        </SubscriptionInfo>
      </Box>
    </Box>
  )
}
